module.exports = __webpack_public_path__ + "static/media/21.931add75.jpeg";